export enum EditManySellersActions {
    Status = 'STATUS',
    Consultor = 'CONSULTOR'
}

export const EditManySellersOptions = [
    {
        label: 'Atualizar consultor comercial',
        value: EditManySellersActions.Consultor
    },
    {
        label: 'Atualizar status',
        value: EditManySellersActions.Status
    }
];